import React, {useContext, useEffect, useState} from 'react';
import { Row, Col } from "react-bootstrap";

import { FaCalendar, FaBuilding, FaClock } from 'react-icons/fa';

import Ticket from '../../components/Ticket';

import UserContext from '../../context/User/UserContext';
import SalarySettlementContext from '../../context/SalarySettlement/SalarySettlementContext';

import CustomCard from '../../components/CustomCard'
import Liquidations from '../../components/Liquidation/index'

const SalarySettlement = () => {

    const userContext = useContext(UserContext);
    const salarySettlementContext = useContext(SalarySettlementContext);
    
    const { user, loading, getDataUser } = userContext;

    const { downloadLiquidation } = salarySettlementContext;

    const [data, setData] = useState({        
        contract: {
            workPosition: null,
            entryTime: null,
            salary: null,
            hiringDate: null            
        }
    });    
 
    useEffect( () => {  
        if(!user) {getDataUser();}
        else { setData(user); }
        // eslint-disable-next-line
    }, [user])

    return (
        <>
             <Row>
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Liquidaciones de Sueldo</h1>
                    <hr />
                </Col>
            </Row>

            <Row>
                <Ticket col={4} loading={loading} variant={"info"} title={"Cargo"} body={data.contract.workPosition} icon={<FaBuilding size={"2rem"} />} />
                <Ticket col={4} loading={loading} variant={"warning"} title={"Horario de Trabajo"} body={`${data.contract.entryTime} - ${data.contract.departureTime}`} icon={<FaClock size={"2rem"} />}/>
                {/*
                <Ticket col={3} loading={loading} variant={"success"} title={"Sueldo Base"} body={data.contract.salary} icon={<FaDollarSign size={"2rem"} />}/>
                */}
                <Ticket col={4} loading={loading} variant={"info"} title={"Fecha de ingreso"} body={data.contract.hiringDate} icon={<FaCalendar size={"2rem"} />}/>                
                
            </Row>

            <Row>     
                <Col sm="12">
                    <CustomCard 
                        titleHeader={"Liquidaciones"}
                    >
                         <p><strong>* Si falta un documento favor comunicarse con dchavez@idesoft.cl</strong></p>
                        <Liquidations
                            loading={loading}
                            user={user}
                            eventDownloadLiquidation={downloadLiquidation}
                        />

                    </CustomCard>
                </Col>                
            </Row>
           
        </>
      );
}
 
export default SalarySettlement;